import { Flex, Grid, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useState } from "react";
import Logo from "../../../components/Logo";
import Navigation from "./navigation";
import Container from "../container";

import classes from "./header.module.css";
import { useNav } from "../../hooks/useNav";

const { useBreakpoint } = Grid;

const Header = () => {
  const { lg } = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);
  const { navSurvey, navLogin, navExperts } = useNav();

  return (
    <header className={classes.root}>
      <Flex
        vertical
        justify="center"
        className={classes.content}
      >
        <Container
          vertical={false}
          centered
          style={{
            overflow: "visible"
          }}
        >
          <Flex gap={32}>
            <Logo width={178} />
            {lg && <Navigation/>}
          </Flex>
          <Flex gap={12} className="ml-auto">
            {lg ? (
              <>
                <Button
                  onClick={navLogin}
                  type="text"
                  size="large"
                >
                  Accedi
                </Button>
                <Button
                  onClick={navExperts}
                  size="large"
                  type="primary"
                >
                  Prenota la tua visita
                </Button>
                <Button
                  onClick={navSurvey}
                  size="large"
                >
                  Inizia questionario
                </Button>
              </>
            ) : <Button type="dashed" size="large" icon={<MenuOutlined color="#344054" />} onClick={() => setIsOpen(state => !state)}/>}
          </Flex>
        </Container>
      </Flex>
      {!lg && (
      <div
        style={{
          height: isOpen ? undefined : 0,
        }}
        className="overflow-hidden"
      >
        <Flex
          vertical
          align="center"
          gap={16}
          className="py-16"
        >
          <Navigation/>
          <Flex gap={12} wrap="wrap" justify="center" vertical>
            <Button type="text" variant="text" size="large" onClick={navLogin}>Accedi</Button>
            <Button onClick={navExperts} size="large" type="primary">Prenota la tua visita</Button>
            <Button size="large" onClick={navSurvey}>Inizia questionario</Button>
          </Flex>
        </Flex>
      </div>
      )}
    </header>
  );
};

export default Header;
